// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1DV-J","productName":"Table_productName__2OliZ"};